var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02571 18.9663H6.26223L15.5219 9.70667L14.2854 8.47012L5.02571 17.7298V18.9663ZM18.7295 8.62207L15.3546 5.27789L16.6584 3.97407C16.952 3.68048 17.3091 3.53369 17.7296 3.53369C18.1501 3.53369 18.5071 3.68048 18.8007 3.97407L20.018 5.19134C20.3116 5.48492 20.4635 5.83684 20.4737 6.24709C20.484 6.65734 20.3423 7.00926 20.0487 7.30284L18.7295 8.62207ZM17.6449 9.72204L6.90068 20.4663H3.52576V17.0913L14.27 6.34709L17.6449 9.72204ZM14.8988 9.08359L14.2854 8.47012L15.5219 9.70667L14.8988 9.08359Z",
    fill: "#006CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.38504efc39831732dd5035ba06b5ea2e.svg";
export { ForwardRef as ReactComponent };